export const DATE_FORMAT = 'MM/DD/YYYY';
export const TIME_FORMAT = 'hh:mm:ss A';
export const FILE_TITLE_DATE_FORMAT = 'MM_DD_YYYY';
